
import {Component, Vue, Prop, Emit} from 'vue-property-decorator';
import {FormModel, Modal} from 'ant-design-vue';
import moment, {Moment} from 'moment';
import {editScheduleApi, addScheduleApi, getDirByIdApi, getAllClassListApi, getTeacherByClassIdListApi} from './api';
import {isSectionTimeDisabled} from './utils';
import ScrollSelect from '@/components/ScrollSelect/index.vue';
interface CourseOption {
    value: string;
    label: string;
    children?: CourseOption[];
    loading?: boolean;
    courseVersion?: number;
}
interface CreateData {
    id?: string;
    schoolId?: string;
    classId?: string;
    teacherId?: string;
    repeatType?: '1' | '2' | '3';
    autoAssignLessons?: boolean;
    remark?: string;
    scheduleDate?:
        | {
              classIndex?: string;
              date: string;
          }
        | string;
    classIndex?: string;
    scheduleClassContent?: {
        courseId: string;
        cascadedNodeIds: string[];
    };
    scheduleRange?: {
        repeatStartDate: string;
        repeatEndDate: string;
        scheduleTimes: {
            dayOfWeek: number;
            classIndex?: string;
        }[];
    };
}
export interface DefaultData {
    id?: string;
    classId?: string;
    teacherId?: string;
    courses?: string[];
    repeatType?: '1' | '2' | '3';
    autoAssignLessons?: boolean;
    remark?: string;
    scheduledDate?: string;
    date?: Moment;
    classIndex?: string;
    repeatEndDate?: Moment | null;
    scheduleClassContent?: {
        courseId: string;
        cascadedNodeIds: string[];
    };
}
export const DateFormat = 'YYYY-MM-DD';
@Component({
    components: {ScrollSelect}
})
export default class EditScheduleDialog extends Vue {
    @Prop({default: () => []}) timeList?: {startTime: string; endTime: string; text: string; disabled?: boolean}[];
    @Prop({default: () => {}}) defaultData?: DefaultData;
    loading = false;
    loadingClass = false;
    loadingTeacher = false;

    form: {
        classId?: string;
        teacherId?: string;
        courses: string[];
        repeatType: '1' | '2' | '3';
        autoAssignLessons: boolean;
        remark: string;
        date?: Moment;
        // date: new Date(),
        classIndex?: string;
        repeatEndDate: Moment | null;
    } = {
        classId: undefined,
        teacherId: undefined,
        courses: [],
        repeatType: '1',
        autoAssignLessons: false,
        remark: '',
        date: undefined,
        // date: moment().add(1, 'day'),
        classIndex: undefined,
        repeatEndDate: null
    };
    classList: {label: string; value: string}[] = [];
    teacherList: {label: string; value: string}[] = [];
    repeatList = [
        {
            label: '不重复',
            value: '1'
        },
        {
            label: '每周重复',
            value: '2'
        },
        {
            label: '单双周重复',
            value: '3'
        }
    ];
    // timeList = [];
    courseList: CourseOption[] = [];
    editLoading = false;

    rules = {
        classId: [{required: true, message: '请选择上课班级'}],
        teacherId: [{required: true, message: '请选择上课老师', trigger: 'blur'}],
        repeatType: [{required: true, message: '请选择'}],
        autoAssignLessons: [{required: true, message: '请选择'}],
        date: [
            {required: true, message: '请选择上课时间'},
            {validator: this.validateDate, trigger: 'blur'}
        ],
        repeatEndDate: [{required: true, message: '请选择结束时间', trigger: ['change']}]
    };
    schoolId = '';
    get isRepeat() {
        return +this.form.repeatType > 1;
    }
    get hasCourses() {
        return !!(this.form.courses && this.form.courses.length);
    }
    get editId() {
        return this.defaultData?.id;
    }
    get renderTimeList() {
        const isToday = this.form.date && moment().format(DateFormat) === this.form.date.format(DateFormat);
        return isToday && this.timeList
            ? this.timeList.map(item => {
                  const disabled = isSectionTimeDisabled(item.endTime);
                  return {
                      ...item,
                      disabled
                  };
              })
            : this.timeList;
    }
    get timeListTextLen() {
        return this.timeList?.reduce((result, x) => {
            if (x.text.length > result) result = x.text.length;
            return result;
        }, 3);
    }

    async created() {
        this.editLoading = !!this.editId;
        let value = window.localStorage.getItem('aicp_school_materials_$state_aicp_school_materials');
        this.schoolId = JSON.parse(value as string).schoolId;
        this.form = {...this.form, ...this.defaultData};
        await this.getClassList();
        this.editLoading = false;
    }
    validateDate(rule: any, value: string, callback: any) {
        if (!value || this.form.classIndex === undefined) {
            return callback(new Error('请选择上课时间'));
        }
        callback();
    }

    disabledStartDate(current: Moment) {
        return current && current < moment().startOf('day');
    }

    disabledEndDate(endValue: Moment) {
        const startValue = this.form.date;
        if (!endValue || !startValue) {
            return false;
        }
        return startValue.valueOf() >= endValue.valueOf() || endValue.valueOf() > moment(startValue.valueOf()).add(2, 'year').valueOf();
    }

    changeDate(date: Moment) {
        this.form.date = date;
        const {repeatEndDate, classIndex} = this.form;
        if (repeatEndDate && repeatEndDate.valueOf() <= date.valueOf()) {
            this.form.repeatEndDate = null;
        }
        const isToday = moment().format(DateFormat) === date.format(DateFormat);
        if (
            isToday &&
            classIndex !== undefined &&
            this.renderTimeList &&
            this.renderTimeList[+classIndex] &&
            this.renderTimeList[+classIndex].disabled
        ) {
            this.form.classIndex = undefined;
        }
    }

    changeClass(value: string) {
        this.form.classId = value;
        this.form.teacherId = undefined;
        this.getTeacherList();
    }

    changeRepeat(value: string) {
        this.form.autoAssignLessons = +value > 1 && this.hasCourses;
    }

    changeCourse(value: string) {
        if (!value.length) {
            this.form.autoAssignLessons = false;
        }
    }

    popupVisibleChange(value: boolean) {
        if (!value && this.hasCourses && this.form.courses.length === 2) {
            this.form.courses = [];
        }
    }
    changeTeacher() {
        this.form.courses = [];
    }

    async initCourseDir() {
        const {courses} = this.form;
        if (courses.length <= 1) return;
        const [courseId, chapterId] = courses;
        const courseItem = this.courseList.find(x => x.value === courseId);
        if (!courseItem) return;
        await this.loadCourseData([courseItem]);
        if (!courseItem.children) return;
        const chapterItem = courseItem.children.find(x => x.value === chapterId);
        if (!chapterItem) return;
        await this.loadCourseData([courseItem, chapterItem]);
    }
    async loadCourseData(selectedOptions: CourseOption[]) {
        const length = selectedOptions.length;
        const targetOption = selectedOptions[length - 1];
        targetOption.loading = true;
        if (length > 0) {
            const urlParams = {
                courseId: selectedOptions[0].value,
                published: 1,
                directoryId: '',
                contentVersion: selectedOptions[0].courseVersion
            };
            if (length > 1) {
                urlParams.directoryId = selectedOptions[length - 1].value;
            }
            const res = await getDirByIdApi(urlParams);
            targetOption.loading = false;
            if (res) {
                targetOption.children = res.data.files.map((file: {name: string; id: string}) => {
                    return {
                        label: file.name,
                        value: file.id,
                        isLeaf: length >= 2
                    };
                });
                this.courseList = [...this.courseList];
            }
        }
    }

    handleCancel() {
        this.$emit('closeModal');
    }
    handleOk() {
        let form = this.$refs.form as FormModel;
        form.validate(async valid => {
            if (valid && this.form.date) {
                this.loading = true;
                const {classId, teacherId, repeatType, autoAssignLessons, remark, date, classIndex, repeatEndDate, courses} = this.form;
                const repeatStartDate = date.format(DateFormat);
                const {endTime} = (this.timeList && this.timeList[Number(classIndex)]) || {};
                if (moment(`${repeatStartDate} ${endTime}`, 'YYYY-MM-DD hh:mm').valueOf() < moment().valueOf()) {
                    this.loading = false;
                    return this.$message.error('开课时间不能早于当前时间');
                }

                const data: CreateData = {
                    schoolId: this.schoolId,
                    classId,
                    teacherId,
                    repeatType,
                    autoAssignLessons,
                    remark,
                    scheduleDate: {
                        classIndex,
                        date: repeatStartDate
                    }
                };
                if (this.hasCourses) {
                    data.scheduleClassContent = {
                        courseId: courses[0],
                        cascadedNodeIds: courses[1] && courses[2] ? [courses[1], courses[2]] : []
                    };
                }
                if (this.isRepeat) {
                    const dayOfWeek = date.weekday() + 1;
                    data.scheduleRange = {
                        repeatStartDate,
                        repeatEndDate: repeatEndDate ? repeatEndDate.format(DateFormat) : '',
                        scheduleTimes: [
                            {
                                dayOfWeek,
                                classIndex
                            }
                        ]
                    };
                }
                if (this.editId) {
                    data.id = this.editId;
                    data.scheduleDate = repeatStartDate;
                    data.classIndex = classIndex;
                    if (!this.hasCourses) {
                        data.scheduleClassContent = {courseId: '', cascadedNodeIds: []};
                    }
                } else {
                    data.scheduleDate = {
                        classIndex,
                        date: repeatStartDate
                    };
                }
                if (this.editId) {
                    const res = await editScheduleApi(data);
                    this.loading = false;
                    if (res && res.code === 40901) {
                        const {startTime, endTime} = (this.timeList && this.timeList[Number(classIndex)]) || {};
                        return this.$message.error(`排课失败！${repeatStartDate} ${startTime}-${endTime}已被安排`);
                    }
                    if (res && res.data) {
                        this.$emit('ok', res.data);
                        this.handleCancel();
                        this.$message.success('排课成功！');
                    }
                    return;
                }

                const res = await addScheduleApi(data);
                this.loading = false;
                if (res && res.data) {
                    const conflictLen = res.data.conflict && res.data.conflict.length;
                    const failLen = res.data.fail && res.data.fail.length;
                    const successLen = res.data.success && res.data.success.length;
                    const totalFail = conflictLen || failLen;

                    if (totalFail) {
                        this.handleCancel();
                        const conflictText = res.data.conflict.map((item: any) => {
                            const {startTime, endTime} = (this.timeList && this.timeList[item.classIndex]) || {};
                            return `${item.scheduledDate} ${startTime}-${endTime}已被安排`;
                            // `排课失败！${_data.className} ${_data.teacherName}老师 ${_data.scheduledDate} ${startTime}-${endTime}已被安排`
                        });
                        const failText = res.data.fail.map((item: any) => {
                            const {startTime, endTime} = (this.timeList && this.timeList[item.classIndex]) || {};
                            return `${item.scheduledDate} ${startTime}-${endTime}网络异常`;
                        });
                        Modal.info({
                            title: '温馨提示',
                            okText: '好的',
                            icon: (h: any) =>
                                h('a-icon', {
                                    attrs: {type: 'info-circle', style: 'color: #1456ed;'}
                                }),
                            content: (h: any) =>
                                h(
                                    'div',
                                    [
                                        h('div', `成功添加排课${successLen}节，失败${totalFail}节`),
                                        h('div', {attrs: {style: 'margin: 18px 0 4px;'}}, '失败原因：')
                                    ].concat(conflictText.concat(failText).map((text: string) => h('div', text)))
                                ),
                            onOk: async () => {
                                if (successLen) {
                                    this.$emit('ok', res.data.success[0]);
                                }
                            }
                        });
                    } else if (successLen) {
                        this.$emit('ok', res.data.success[0]);
                        this.handleCancel();
                        this.$message.success('排课成功！');
                    }
                }
            } else {
                return false;
            }
        });
    }

    getClassList() {
        return new Promise(resolve => {
            let urlQueryParmas: any = {
                schoolId: this.schoolId
            };
            if (this.loadingClass) return;
            this.loadingClass = true;
            getAllClassListApi(urlQueryParmas, this).then(async res => {
                if (res && res.data) {
                    this.classList = res.data.map((item: {_id: string; name: string}) => ({
                        value: item._id,
                        label: item.name
                    }));
                    if (this.form?.classId) {
                        await this.getTeacherList();
                    } else {
                        this.form.teacherId = undefined;
                        this.form.courses = [];
                    }
                }
                this.loadingClass = false;
                resolve(true);
            });
        });
    }

    getTeacherList() {
        return new Promise(resolve => {
            const classId = this.form.classId;
            let urlQueryParmas: any = {
                classIdList: [classId]
            };
            if (this.loadingTeacher) return;
            this.loadingTeacher = true;
            getTeacherByClassIdListApi(urlQueryParmas, this).then(res => {
                if (res) {
                    const teacherList: {label: string; value: string}[] = [];
                    const courseMap = new Map();
                    res.data[0].list.forEach(
                        (item: {
                            teacherId: string;
                            teacherName: string;
                            courseClassData: {courseId: string; courseName: string; classId: string; courseVersion: number}[];
                        }) => {
                            item.courseClassData.forEach(course => {
                                if (course.classId === classId) {
                                    courseMap.set(course.courseId, {
                                        value: course.courseId,
                                        label: course.courseName,
                                        courseVersion: course.courseVersion,
                                        isLeaf: false
                                    });
                                }
                            });
                            teacherList.push({
                                value: item.teacherId,
                                label: item.teacherName
                            });
                        }
                    );
                    this.courseList = Array.from(courseMap.values());
                    if (this.form.courses.length > 1) {
                        this.initCourseDir();
                    }
                    this.teacherList = teacherList;
                    this.loadingTeacher = false;
                    return resolve(true);
                }
                this.loadingTeacher = true;
                resolve(false);
            });
        });
    }
}
